export default [
	'bedc:team:lookup',
	'bedc:team:lookup:{clientId}',
	'bedc:team:lookup:{organizationId}',
	'bedc:team:lookup:self-assign',

	'bedc:team:list',
] as const;
